// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 6 hooks for backend/devplan.

import { useBackend } from '../useBackend'

/** POST /api/devplan/askDevPlanQuestion */
export function useAskDevPlanQuestion<T = any>() {
  return useBackend<T>('devplan/askDevPlanQuestion')
}

/** POST /api/devplan/getDevPlan */
export function useGetDevPlan<T = any>() {
  return useBackend<T>('devplan/getDevPlan')
}

/** POST /api/devplan/getDevPlanRefs */
export function useGetDevPlanRefs<T = any>() {
  return useBackend<T>('devplan/getDevPlanRefs')
}

/** POST /api/devplan/setDevPlanDependencies */
export function useSetDevPlanDependencies<T = any>() {
  return useBackend<T>('devplan/setDevPlanDependencies')
}

/** POST /api/devplan/setDevPlanStatus */
export function useSetDevPlanStatus<T = any>() {
  return useBackend<T>('devplan/setDevPlanStatus')
}

/** POST /api/devplan/upsertDevPlanItem */
export function useUpsertDevPlanItem<T = any>() {
  return useBackend<T>('devplan/upsertDevPlanItem')
}
